export const isIframed = () => {
  try {
    return window.self !== window.top;
  } catch (err) {
    return true;
  }
};
